// Import model
import { StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest } from '../models/StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest - handles JSON serialization and deserialization with type validation
 */
export class StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequestSerializer {
  /**
   * Deserializes a JSON string into a StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest instance
   */
  static deserialize(json: string): StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest instance
   */
  static fromObject(obj: any): StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest');
    }


    const instance: StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest = {
      unlayerTemplateId: obj['UnlayerTemplateId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest instances
   */
  static deserializeArray(json: string): StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest instance to a JSON string
   */
  static serialize(instance: StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest instance to a plain object
   */
  static toObject(instance: StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest): any {
    return {
      'UnlayerTemplateId': instance.unlayerTemplateId,
    };
  }

  /**
   * Serializes an array of StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest instances to a JSON string
   */
  static serializeArray(instances: StartObjectAppointmentSendCustomAppointmentConfirmationEmailRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
